"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductViewerFilter = void 0;
const react_1 = __importStar(require("react"));
const KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const react_redux_1 = require("react-redux");
const partials_1 = require("./partials");
const viewer_table_filter_styles_1 = require("./viewer-table-filter.styles");
const localization_1 = require("../../../localization");
const components_1 = require("../../components");
const search_component_1 = require("../../components/table/search/search.component");
const store_1 = require("../../../store");
const ProductViewerFilter = ({ searchQuery, onSearch, activeColumns, columns, defaultColumns, setActiveColumns, disabled, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedOrganizations = (0, store_1.useSelectedOrganizationsIdsSelector)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const updateFilter = (0, react_1.useCallback)((filter) => {
        dispatch((0, store_1.setAdvancedViewerFilter)(filter));
    }, [dispatch]);
    const [areFiltersDisplayed, setAreFiltersDisplayed] = (0, react_1.useState)(false);
    const onFiltersButtonClick = (0, react_1.useCallback)(() => setAreFiltersDisplayed((prev) => !prev), []);
    return (react_1.default.createElement(viewer_table_filter_styles_1.StyledFiltersWrapper, null, react_1.default.createElement(viewer_table_filter_styles_1.StyledHeaderContainer, null, react_1.default.createElement(viewer_table_filter_styles_1.StyledSearchFilterHeaderRow, null, react_1.default.createElement(viewer_table_filter_styles_1.StyledLeftFilterHeaderWrapper, null, react_1.default.createElement(search_component_1.ProductEditorTableSearch, { searchQuery: searchQuery, onSearch: onSearch }), react_1.default.createElement(viewer_table_filter_styles_1.StyledFilterButton, { onClick: onFiltersButtonClick, title: t({ key: 'FILTERS' }), endIcon: areFiltersDisplayed ? react_1.default.createElement(KeyboardArrowUp_1.default, null) : react_1.default.createElement(KeyboardArrowDown_1.default, null), color: "primary", rounded: true, variant: "outlined", disabled: !(selectedOrganizations === null || selectedOrganizations === void 0 ? void 0 : selectedOrganizations.length) })), react_1.default.createElement("div", null, react_1.default.createElement(components_1.RefineModalButton, { activeColumns: activeColumns, columns: columns, defaultColumns: defaultColumns, setActiveColumns: setActiveColumns, disabled: disabled }, react_1.default.createElement("span", null, (t({ key: 'VIEW_OPTIONS' })).toUpperCase()))))), areFiltersDisplayed && (react_1.default.createElement(partials_1.Filters, { updateFilter: updateFilter }))));
};
exports.ProductViewerFilter = ProductViewerFilter;
exports.default = exports.ProductViewerFilter;
